import React, {useEffect, useState, Component, Fragment} from 'react';
import axios from 'axios';
import {connect} from 'react-redux';
import Iframe from "react-iframe"
import { Redirect,Link } from 'react-router-dom';
import { Placeholder,Popup } from 'semantic-ui-react';
import {
  Menu,
  Container,
  Segment,
  Table,
  Divider,
  Message,
  Icon,
  Header,
  Dimmer,
  Responsive,
  Modal,
  Button,
  Step,
  Loader,
  Tab,
  Label
} from 'semantic-ui-react';
import {Base64} from 'js-base64';
import QRCode from 'qrcode.react';
import Clipboard from 'react-clipboard.js';
import { Sparklines, SparklinesBars, SparklinesLine, SparklinesReferenceLine } from 'react-sparklines';

var id = false;

let average = (array) => array.reduce((a, b) => a + b) / array.length;

function Guide(props){

  var base          = 30;
  const {t}         = props;
  const mobile      = /Android|iPhone|iPod/.test(navigator.userAgent);
  const port        = props.data.port;
  const prefix      = props.data.prefix;
  const code        = props.data.code;
  const hashed      = props.data.hashed;
  const user_id     = props.data.user_id;
  const user_vip    = props.data.user_vip;
  const leftDays    = props.data.leftDays;

  if(user_id < 515375){
    base = 20;
  }

  var subscribe_endpoint = "update.glados-config.com";
  //subscribe_endpoint = "update.glados-config.net";
  //subscribe_endpoint = "update.glados-config.org";

  const sub    = 'sub://' + Base64.encode(`https://${subscribe_endpoint}/shadowsocks/${user_id}/${hashed}`) + "#GLaDOS-GAME";
  const suburl        = `https://${subscribe_endpoint}/shadowsocks/${user_id}/${hashed}`;
  const sip008        = `https://${subscribe_endpoint}/sip008/${user_id}/${hashed}`;
  const netchDownload = "https://github.com/netchx/netch/releases"
  const suburl_netch  = `https://${subscribe_endpoint}/netch/${user_id}/${hashed}`

  const not_supported = <Fragment>
        <Segment placeholder>
          <Header icon>
            <Icon name='cloud upload' />
            <p>游戏加速仅为 Pro 用户提供</p>
          </Header>
          <Link to="/console/shop">
            <Button primary>升级</Button>
          </Link>
        </Segment>
  </Fragment>

  const [clipboard,setClipboard] = useState(false);

  var panes = [{
      menuItem:<Menu.Item key='pro34'>
        PC/Steam 加速
      </Menu.Item>,
      display:true,
      render: () => {
        return (<Tab.Pane style={{padding:"10px",margin:"0px"}}>

          {user_vip>base || (user_vip == 10 && leftDays > 0 && leftDays < 10)?
          <Fragment>
          <p>加速游戏时请关闭其他代理工具, 仅运行 Netch .</p>
          <p>为保证联机质量, 联机游戏节点仅供联机游戏使用, 请不要用来下载游戏。</p>
          <Table>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>PC 配置</Table.HeaderCell>
                <Table.HeaderCell></Table.HeaderCell>
              </Table.Row>
            </Table.Header>

            <Table.Body>
              <Table.Row>
                <Table.Cell>游戏加速器下载</Table.Cell>
                <Table.Cell  singleLine   textAlign='right'>
                  <a href="https://github.com/netchx/netch/releases/tag/1.9.2">Netch 1.9.2</a>
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>订阅文件</Table.Cell>
                <Table.Cell collapsing textAlign='right'>
                  {suburl_netch}
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>游戏联机节点(10X)</Table.Cell>
                <Table.Cell collapsing textAlign='right'>
                  <Label color="green">GLaDOS-GAME</Label>
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>游戏下载节点(1X)</Table.Cell>
                <Table.Cell collapsing textAlign='right'>
                  <Label color="blue">GLaDOS-Portalgun</Label>
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>推荐模式</Table.Cell>
                <Table.Cell collapsing textAlign='right'>
                  <Label>Bypass LAN and China</Label>
                </Table.Cell>
              </Table.Row>

            </Table.Body>
          </Table>

          </Fragment>
              :not_supported }

        </Tab.Pane>)
      }
  },{
      menuItem:<Menu.Item key='pro34'>
        Switch/PS/XBOX 联机加速
      </Menu.Item>,
      display:true,
      render: () => {
        return (<Tab.Pane style={{padding:"10px",margin:"0px"}}>

          <p>GLaDOS 可用于加速主机游戏, 提升NAT类型降低游戏延迟。</p>

          {user_vip>base?
          <Fragment>

          <p>请在 PC 上运行加速器</p>
          <Table>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>PC 配置</Table.HeaderCell>
                <Table.HeaderCell></Table.HeaderCell>
              </Table.Row>
            </Table.Header>

            <Table.Body>
              <Table.Row>
                <Table.Cell>游戏加速器下载</Table.Cell>
                <Table.Cell  singleLine   textAlign='right'>
                  <a href="https://github.com/netchx/netch/releases/tag/1.9.2">Netch 1.9.2</a>
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>订阅文件</Table.Cell>
                <Table.Cell collapsing textAlign='right'>
                  {suburl_netch}
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>游戏节点</Table.Cell>
                <Table.Cell collapsing textAlign='right'>
                  <Label color="green">GLaDOS-GAME-JP</Label>
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>特别注意</Table.Cell>
                <Table.Cell collapsing textAlign='right'>
                  仅限游戏联机使用，请勿下载/更新游戏
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>主机加速模式</Table.Cell>
                <Table.Cell collapsing textAlign='right'>
                  <Label>[pcap2socks] Tencent(10.6.0.1) Preset</Label>
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>主机加速需要安装</Table.Cell>
                <Table.Cell collapsing textAlign='right'>
                  <Label><a href="https://nmap.org/npcap/dist/npcap-1.50.exe">Npcap</a></Label>
                </Table.Cell>
              </Table.Row>

            </Table.Body>
          </Table>

          <p>请把主机与PC连在一个路由器上，并在游戏主机里配置网络:</p>
          <Table>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Switch/PS/XBOX 网络配置</Table.HeaderCell>
                <Table.HeaderCell></Table.HeaderCell>
              </Table.Row>
            </Table.Header>

            <Table.Body>
              <Table.Row>
                <Table.Cell>IP</Table.Cell>
                <Table.Cell  singleLine   textAlign='right'>
                  10.6.0.1(手动配置)
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Gateway(网关)</Table.Cell>
                <Table.Cell collapsing textAlign='right'>
                  10.6.0.2(手动配置)
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Mask(子网掩码)</Table.Cell>
                <Table.Cell collapsing textAlign='right'>
                  255.255.255.0
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>DNS</Table.Cell>
                <Table.Cell collapsing textAlign='right'>
                  1.1.1.1
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>代理服务器</Table.Cell>
                <Table.Cell collapsing textAlign='right'>
                  关闭
                </Table.Cell>
              </Table.Row>

            </Table.Body>
          </Table>

          </Fragment>
              :not_supported }

        </Tab.Pane>)
      }
  },{
      menuItem:<Menu.Item key='pro34'>
        iOS 游戏加速
      </Menu.Item>,
      display:true,
      render: () => {
        return (<Tab.Pane style={{padding:"10px",margin:"0px"}}>

          {user_vip>base?
          <Fragment>

          <Table>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Shadowrocket 配置</Table.HeaderCell>
                <Table.HeaderCell></Table.HeaderCell>
              </Table.Row>
            </Table.Header>

            <Table.Body>
              <Table.Row>
                <Table.Cell>工具</Table.Cell>
                <Table.Cell  singleLine   textAlign='right'>
                  Shadowrocket
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell textAlign='top'>订阅二维码</Table.Cell>
                <Table.Cell collapsing textAlign='right'>
                <QRCode value={sub} size={192} />
                </Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>

          </Fragment>
              :not_supported }

        </Tab.Pane>)
      }
  },{
      menuItem:<Menu.Item key='pro34'>
        Nintendo Switch 下载加速
      </Menu.Item>,
      display:true,
      render: () => {
        return (<Tab.Pane style={{padding:"10px",margin:"0px"}}>
          <p>Nintendo Switch 下载加速服务已经关闭</p>
          <p>您可以通过为局域网开放 Clash 的 HTTP 端口加速您的Switch</p>
        </Tab.Pane>)
      }
  }]

  return (

    <Fragment>

      <Header as='h2' color="blue">
        通用游戏加速
        <Header.Subheader>
          加速游戏联机速度
        </Header.Subheader>
      </Header>

      <p>GLaDOS 游戏线路优化实时网络, 实现了NAT FULLCONE，可以更稳定的联机和匹配玩家.</p>
      <p><b>为保证联机游戏效果，联机线路(GLaDOS-GAME)对非游戏内容，游戏下载和视频进行了限流(最高100KB/s).</b></p>
      {user_vip == 10? <p><b>升级到Pro前，您可以测试游戏加速，测试线路并不稳定，仅为用户调试设备和测试游戏使用，升级后会开放新的线路。</b></p>:<p></p>}
      <Tab panes={panes.filter((i)=>{return i.display})} />

    </Fragment>
  )
}


/*
          <p>GLaDOS 可用于加速 Nintendo Switch eShop 下载, 无需 PC 运行加速器</p>
          <p>请注意不通过PC加速时，不能提升您的网络类型以提升联机游戏的网络能力。</p>
          <p>请点击设置-互联网-无线-更改网络设置-启用代理服务器 然后按照下面的信息配置代理服务器.</p>

          {user_vip>base?
          <Fragment>

          <Table>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Switch 代理服务器配置</Table.HeaderCell>
                <Table.HeaderCell></Table.HeaderCell>
              </Table.Row>
            </Table.Header>

            <Table.Body>
              <Table.Row>
                <Table.Cell>服务器</Table.Cell>
                <Table.Cell  singleLine   textAlign='right'>
                  switch.gladns.com
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>端口</Table.Cell>
                <Table.Cell collapsing textAlign='right'>
                  3001
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>自动验证</Table.Cell>
                <Table.Cell collapsing textAlign='right'>
                  启用
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>用户名</Table.Cell>
                <Table.Cell collapsing textAlign='right'>
                  { props.data.port > 99999 ? props.data.port : (props.data.user_id * 100000  +  props.data.port)}
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>密码</Table.Cell>
                <Table.Cell collapsing textAlign='right'>
                  { props.data.password }
                </Table.Cell>
              </Table.Row>

            </Table.Body>
          </Table>

          </Fragment>
              :not_supported }
*/

export {Guide};
